import React from 'react';
import styles from './ccf-acd-header.module.scss';
import { Divider, Popover } from '@mui/material';
import {
  CcfBox,
  CcfTypography,
  CcfAcdNotificationIndicatorIcon,
  CcfAcdNewNotificationIcon,
  CcfAcdLogoutIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { loginActions } from '../login/+state/login.slice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  selectVoicePrefCheckboxState,
  voicePreferenceActions,
} from '../ccf-voice-preference/agentSessionSlice';
import { globalActions } from '../global.app.slice';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isEternalsEnv } from '../../util/common';

/* eslint-disable-next-line */
export interface CcfAcdHeaderPopoverProps {
  anchorEl?: any;
  currentContact?: any;
  handleClose?: any;
  hideMediaControlClicked?: any;
  popoverFeature?: any;
}

/**
 * Component displays App header popover on clicking on header icons
 * @param props -CcfAcdHeaderPopoverProps
 * @returns app header component for landing screen
 * @example <CcfAcdHeaderPopover/>
 */
export function CcfAcdHeaderPopover(props: CcfAcdHeaderPopoverProps) {
  const { logOutUser } = loginActions;
  const { resetVoicePrefState } = voicePreferenceActions;
  const { setredirectToDashboardOnLogout } = voicePreferenceActions;
  const voicePrefernceRememberOption = useSelector(
    selectVoicePrefCheckboxState
  );
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();  
  const dispatch = useDispatch();
  const [translate] = useTranslator();
  const { setAuthenticationStage } = globalActions;

  const notificationdata = [
    {
      heading: 'Password Expiration',
      subHeading: 'Your password will expire in 9 days',
      timer: 'Just Now',
      newNotification: true,
    },
    {
      heading: 'Email Address Verfied',
      subHeading: 'You have sucessfully verfied your email address',
      timer: 'Just Now',
      newNotification: true,
    },
    {
      heading: 'New time off request',
      subHeading: 'Ryan johnson',
      timer: 'April 17,2020 2:22 PM',
      newNotification: false,
    },
    {
      heading: 'Time off request cancelled',
      subHeading: 'Sammy Davis',
      timer: 'April 15,2020 3:45 PM',
      newNotification: false,
    },
    {
      heading: 'New time off request',
      subHeading: 'Ashley Simpson',
      timer: 'April 12,2020 9:55 AM',
      newNotification: false,
    },
  ];

  /**
   * Function to handle icon for status
   * @param status - string
   * @example handleIconForStatus()
   * @returns
   */
  const signOutUser = () => {
    if (isAuthenticated) {
      instance.logoutRedirect({
        postLogoutRedirectUri: '/',
      });
      if(!isEternalsEnv()){
        dispatch(setAuthenticationStage(1));
      }
    } else {
      dispatch(logOutUser(false));
      dispatch(setredirectToDashboardOnLogout());
      if (!voicePrefernceRememberOption.checkboxVal) {
        dispatch(resetVoicePrefState());
      }
    }
  };
  return (
    <Popover
      id={'voicemail-outbound-popover'}
      style={{
        marginTop: '40px',
      }}
      open={Boolean(props?.anchorEl)}
      keepMounted
      anchorEl={props?.anchorEl}
      onClose={props?.handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      {props?.popoverFeature === 'Notification' ? (
        <CcfBox className={styles.notificationPopupContainer}>
          <CcfBox className={styles.headerSection}>
            <CcfTypography className={styles.txtNotifications}>
              Notifications
            </CcfTypography>
            <span style={{ marginRight: '10px' }}>
              <CcfAcdNotificationIndicatorIcon />
            </span>
          </CcfBox>
          <Divider style={{ height: '1px', width: '100%' }} />
          <CcfBox
            style={{
              maxHeight: '445px',
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'scroll',
            }}
          >
            {notificationdata.map((notification: any) => {
              return (
                <div
                  style={{
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    minHeight: '92px',
                    backgroundColor: notification.newNotification
                      ? '#FFFFF'
                      : '#FAFCFC',
                    border: '1px solid #EDEDED',
                  }}
                >
                  <CcfBox
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <CcfTypography className={styles.notificationHeading}>
                      {notification.heading}
                    </CcfTypography>
                    {notification.newNotification && (
                      <CcfAcdNewNotificationIcon style={{ fontSize: '10px' }} />
                    )}
                  </CcfBox>
                  <CcfTypography className={styles.notificationSubHeading}>
                    {notification.subHeading}
                  </CcfTypography>
                  <CcfTypography className={styles.notificationTimer}>
                    {notification.timer}
                  </CcfTypography>

                  {/* <Divider
                    style={{ height: '1px', width: '100%', marginTop: '16px' }}
                  /> */}
                </div>
              );
            })}
          </CcfBox>
        </CcfBox>
      ) : props?.popoverFeature === 'Dashboard' ? (
        <CcfBox className={styles.FavouritePopupContainer}>
          <CcfBox className={styles.favouriteHeaderSection}>
            <CcfTypography className={styles.headerTitle}>
              Favourite Dashboard
            </CcfTypography>
          </CcfBox>
          <Divider style={{ height: '1px', width: '100%' }} />
          <CcfBox
            marginTop={'5px'}
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            {' '}
            <CcfBox className={styles.favBtnContainer}>
              <CcfBox style={{ width: '100%', padding: '16px' }}>
                <CcfTypography className={styles.favListText}>
                  My Stats
                </CcfTypography>
                <CcfTypography className={styles.favListText}>
                  My Team Stats
                </CcfTypography>
                <CcfTypography className={styles.favListText}>
                  Contact Center Dashboard
                </CcfTypography>
                <CcfTypography className={styles.favListText}>
                  Supervisor Overview
                </CcfTypography>
              </CcfBox>
            </CcfBox>
          </CcfBox>
        </CcfBox>
      ) : (
        <CcfBox className={styles.signoutPopupContainer}>
          <CcfBox className={styles.signoutContainer}>
            <CcfBox style={{ width: '100%' }}>
              <CcfTypography
                className={styles.scheduleTxt}
                style={{ paddingBottom: '18px' }}
              >
                {translate('schedule')}
              </CcfTypography>
              <CcfTypography className={styles.scheduleTxt}>
                {translate('changePassword')}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
          <Divider style={{ height: '1px', width: '100%' }} />
          <CcfBox marginTop={'10px'}></CcfBox>

          <CcfBox className={styles.signoutContainer}>
            <CcfBox style={{ width: '100%' }}>
              <CcfTypography
                className={styles.scheduleTxt}
                style={{ paddingBottom: '18px' }}
              >
                {translate('supportDownloads')}
              </CcfTypography>
              <CcfTypography className={styles.scheduleTxt}>
                {translate('contactus')}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
          <Divider style={{ height: '1px', width: '100%' }} />
          <CcfBox className={styles.signOutBtnContainer}>
            <CcfBox
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                marginLeft: '10px',
              }}
              onClick={signOutUser}
            >
              <CcfAcdLogoutIcon style={{ fontSize: '16px' }} />
              <CcfTypography className={styles.scheduleTxt}>
                {translate('logOut')}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
        </CcfBox>
      )}
    </Popover>
  );
}

export default CcfAcdHeaderPopover;
